// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deletion Progress Modal Styles */
.deletion-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

.deletion-modal-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: 480px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideInScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
}

/* Header Section */
.deletion-modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 32px 24px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  position: relative;
}

.deletion-modal-icon {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.deleting-icon {
  animation: pulse 2s infinite;
}

.success-icon {
  animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.deletion-modal-title h3 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}

.deletion-modal-subtitle {
  margin: 0;
  font-size: 15px;
  color: #64748b;
  font-weight: 400;
}

/* Content Section */
.deletion-modal-content {
  padding: 32px 24px;
}

/* Progress Bar Container */
.progress-container {
  position: relative;
  margin-bottom: 24px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 8px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer 1.5s infinite;
}

.progress-text {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

/* Current File Section */
.current-file {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 24px;
  animation: slideInUp 0.3s ease-out;
}

.current-file-icon {
  margin-right: 12px;
  flex-shrink: 0;
}

.current-file-name {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Loading Dots */
.loading-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  background: #3b82f6;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

/* Footer Section */
.deletion-modal-footer {
  padding: 20px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
}

.deletion-complete-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px 0 rgba(16, 185, 129, 0.3);
}

.deletion-complete-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px 0 rgba(16, 185, 129, 0.4);
}

.deletion-complete-btn:active {
  transform: translateY(0);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInScale {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

@keyframes bounceIn {
  0% {
    transform: scale(0.3);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .deletion-modal-container {
    background: #1e293b;
    border: 1px solid #334155;
  }
  
  .deletion-modal-header {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    border-bottom-color: #475569;
  }
  
  .deletion-modal-title h3 {
    color: #f1f5f9;
  }
  
  .deletion-modal-subtitle {
    color: #94a3b8;
  }
  
  .progress-bar {
    background: #475569;
  }
  
  .progress-text {
    color: #cbd5e1;
  }
  
  .current-file {
    background: #334155;
    border-color: #475569;
  }
  
  .current-file-name {
    color: #cbd5e1;
  }
  
  .deletion-modal-footer {
    background: #1e293b;
    border-top-color: #475569;
  }
}

/* Mobile Responsiveness */
@media (max-width: 640px) {
  .deletion-modal-container {
    margin: 16px;
    width: calc(100% - 32px);
    border-radius: 12px;
  }
  
  .deletion-modal-header {
    padding: 24px 20px;
  }
  
  .deletion-modal-content {
    padding: 24px 20px;
  }
  
  .deletion-modal-footer {
    padding: 16px 20px;
  }
  
  .deletion-modal-title h3 {
    font-size: 20px;
  }
  
  .deletion-modal-subtitle {
    font-size: 14px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .deletion-modal-overlay,
  .deletion-modal-container,
  .current-file,
  .progress-fill,
  .deletion-complete-btn {
    animation: none;
    transition: none;
  }
  
  .deleting-icon,
  .success-icon,
  .dot,
  .progress-fill::after {
    animation: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DeletionProgressModal.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;EAClB,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,6DAA6D;IAC7D,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;IAKE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;IAIE,eAAe;EACjB;AACF","sourcesContent":["/* Deletion Progress Modal Styles */\n.deletion-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.deletion-modal-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  max-width: 480px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: slideInScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n}\n\n/* Header Section */\n.deletion-modal-header {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  padding: 32px 24px;\n  text-align: center;\n  border-bottom: 1px solid #e2e8f0;\n  position: relative;\n}\n\n.deletion-modal-icon {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.deleting-icon {\n  animation: pulse 2s infinite;\n}\n\n.success-icon {\n  animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.deletion-modal-title h3 {\n  margin: 0 0 8px 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.3;\n}\n\n.deletion-modal-subtitle {\n  margin: 0;\n  font-size: 15px;\n  color: #64748b;\n  font-weight: 400;\n}\n\n/* Content Section */\n.deletion-modal-content {\n  padding: 32px 24px;\n}\n\n/* Progress Bar Container */\n.progress-container {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);\n  border-radius: 8px;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: shimmer 1.5s infinite;\n}\n\n.progress-text {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* Current File Section */\n.current-file {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  animation: slideInUp 0.3s ease-out;\n}\n\n.current-file-icon {\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.current-file-name {\n  font-size: 14px;\n  color: #475569;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Loading Dots */\n.loading-dots {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background: #3b82f6;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0s;\n}\n\n/* Footer Section */\n.deletion-modal-footer {\n  padding: 20px 24px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: center;\n}\n\n.deletion-complete-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px 0 rgba(16, 185, 129, 0.3);\n}\n\n.deletion-complete-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px 0 rgba(16, 185, 129, 0.4);\n}\n\n.deletion-complete-btn:active {\n  transform: translateY(0);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.8;\n  }\n}\n\n@keyframes bounceIn {\n  0% {\n    transform: scale(0.3);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .deletion-modal-container {\n    background: #1e293b;\n    border: 1px solid #334155;\n  }\n  \n  .deletion-modal-header {\n    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n    border-bottom-color: #475569;\n  }\n  \n  .deletion-modal-title h3 {\n    color: #f1f5f9;\n  }\n  \n  .deletion-modal-subtitle {\n    color: #94a3b8;\n  }\n  \n  .progress-bar {\n    background: #475569;\n  }\n  \n  .progress-text {\n    color: #cbd5e1;\n  }\n  \n  .current-file {\n    background: #334155;\n    border-color: #475569;\n  }\n  \n  .current-file-name {\n    color: #cbd5e1;\n  }\n  \n  .deletion-modal-footer {\n    background: #1e293b;\n    border-top-color: #475569;\n  }\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 640px) {\n  .deletion-modal-container {\n    margin: 16px;\n    width: calc(100% - 32px);\n    border-radius: 12px;\n  }\n  \n  .deletion-modal-header {\n    padding: 24px 20px;\n  }\n  \n  .deletion-modal-content {\n    padding: 24px 20px;\n  }\n  \n  .deletion-modal-footer {\n    padding: 16px 20px;\n  }\n  \n  .deletion-modal-title h3 {\n    font-size: 20px;\n  }\n  \n  .deletion-modal-subtitle {\n    font-size: 14px;\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .deletion-modal-overlay,\n  .deletion-modal-container,\n  .current-file,\n  .progress-fill,\n  .deletion-complete-btn {\n    animation: none;\n    transition: none;\n  }\n  \n  .deleting-icon,\n  .success-icon,\n  .dot,\n  .progress-fill::after {\n    animation: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
